import React, { useContext, useEffect, useState } from "react";
import { PdfViewerContext } from "../../../contexts/PdfViewer/InterceptorContext";
import { Button } from "../../atoms";

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

export const PdfViewer: React.FC = () => {
  const { pdf } = useContext(PdfViewerContext);
  const [pdfUrl, setPdfUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!pdf) {
      return;
    }
    if (pdf instanceof Blob) {
      const url = URL.createObjectURL(pdf);
      setPdfUrl(url);
      return () => {
        URL.revokeObjectURL(url);
      };
    } else if (typeof pdf === "string") {
      setPdfUrl(pdf);
    }
  }, [pdf]);

  if (!pdfUrl) {
    return <div>Loading PDF...</div>;
  }

  const renderPdfViewer = () => {
    if (isIOS) {
      return (
        <div>
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "0.5rem 1rem",
              background: "#00529c25",
              color: "#00529c",
              borderRadius: "4px",
              textDecoration: "none",
              display: "inline-block",
              marginTop: "1rem",
            }}
          >
            Abrir Voucher em PDF
          </a>
        </div>
      );
    }

    return (
      <object
        data={pdfUrl}
        type="application/pdf"
        width="100%"
        height="100%"
        style={{
          border: "none",
        }}
      >
        <p>
          <a
            href={pdfUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: "0.5rem 1rem",
              background: "#00529c25",
              color: "#00529c",
              borderRadius: "4px",
              textDecoration: "none",
            }}
          >
            Clique aqui para ver o seu PDF
          </a>
        </p>
      </object>
    );
  };

  return (
    <div
      style={{
        width: "100%",
        height: "100svh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem",
      }}
    >
      {renderPdfViewer()}
      {!isIOS && (
        <Button
          appearance="primary"
          onClick={() => window.open(pdfUrl, "_blank")}
          style={{ marginTop: "1rem" }}
        >
          Download do PDF
        </Button>
      )}
    </div>
  );
};
